import React from 'react';
import { CUSTOM_FIELDS } from '@nile/components/src/Constants';
import { SVGIcon } from '@superops/super-icons';

export const availableCustomFields = [
  {
    label: 'Short Text',
    key: 'admin.formbuilder.create.shortText',
    value: 'TEXT',
    id: 0,
    icon: <SVGIcon name="ShortText" />
  },
  {
    label: 'Long Text',
    key: 'client.new.addField.long',
    value: 'PARAGRAPH',
    id: 1,
    icon: <SVGIcon name="LongText" />
  },
  {
    label: 'Number',
    key: 'admin.formbuilder.create.number',
    value: 'NUMERIC',
    id: 2,
    icon: <SVGIcon name="Numeric" />
  },
  {
    label: 'Decimal',
    key: 'admin.formbuilder.create.decimal',
    value: 'DECIMAL',
    id: 3,
    icon: <SVGIcon name="Decimal" />
  },
  {
    label: 'Date',
    key: 'admin.formbuilder.create.date',
    value: 'DATE',
    id: 4,
    icon: <SVGIcon name="DatePicker" />
  },
  {
    label: 'DateTime',
    key: 'admin.formbuilder.create.dateTime',
    value: 'DATETIME',
    id: 5,
    icon: <SVGIcon name="DateTime" />
  },
  {
    label: 'Radio',
    key: 'admin.formbuilder.create.radio',
    value: 'RADIO',
    id: 6,
    icon: <SVGIcon name="RadioButton" />,
    options: []
  },
  {
    label: 'Checkbox',
    key: 'admin.formbuilder.create.checkbox',
    value: 'CHECKBOX',
    id: 7,
    icon: <SVGIcon name="CheckBox" />,
    options: []
  },
  {
    label: 'Select',
    key: 'admin.formbuilder.create.select',
    value: 'SELECT',
    id: 8,
    icon: <SVGIcon name="SingleSelect" />
  },
  {
    label: 'Multi Select',
    key: 'admin.formbuilder.create.multiSelect',
    value: 'MULTI_SELECT',
    id: 9,
    icon: <SVGIcon name="MultiSelect" />,
    options: []
  },
  {
    label: 'Secured Text',
    key: 'admin.formbuilder.create.securedText',
    value: 'PASSWORD',
    id: 10,
    icon: <SVGIcon name="Lock" />,
    options: []
  },
  {
    label: 'Secure Text',
    key: 'admin.customFields.secureText',
    value: CUSTOM_FIELDS.secureText,
    id: 10,
    icon: <SVGIcon name="Lock" />,
    options: []
  },
  {
    label: 'Dependent field',
    key: 'admin.customFields.dependent.field',
    value: CUSTOM_FIELDS.depedantField,
    id: 11,
    icon: <SVGIcon name="DependentField" />,
    options: []
  }
];

export const richTextField = {
  label: 'RichTextField',
  key: 'admin.asset.class.rich.text',
  value: 'RICH_TEXT',
  id: 11,
  icon: <SVGIcon name="RichTextEditor" />,
  options: [],
  flag: 'richTextEditorForAssetClass',
  module: ['IT_DOCUMENT']
};

export const assetClassPickItems = [
  'fieldType',
  'module',
  'label',
  'description',
  'options',
  'commonWorkStationField'
];

export const MAIL_SETTINGS_TYPES = {
  support: 'SUPPORT',
  sales: 'CONTACT'
};

export const MAIL_SETTINGS_REPLY_TYPES = {
  custom: 'CUSTOM',
  default: 'DEFAULT'
};

export const MAIL_SETTINGS_RESPONSE_TYPES = {
  msp: 'MSP',
  technician: 'TECHNICIAN',
  client: 'CLIENT',
  company: 'COMPANY'
};

export const fileSizes = {
  fileUploadLimit: 100000000
};
